import { Nullish } from 'types/common';

const get = (storage: Storage) => <Type>(key: string) => {
  const value = storage.getItem(key);

  return decodeValue<Type>(value);
};

const set = (storage: Storage) => <Type>(key: string, value: Type) => {
  const encodedValue = encodeValue(value);

  if (encodedValue) {
    storage.setItem(key, encodedValue);
  } else {
    remove(storage)(key);
  }
};

const remove = (storage: Storage) => (key: string) => {
  storage.removeItem(key);
};

const clear = (storage: Storage) => () => {
  storage.clear();
};

const encodeValue = <Type>(value: Type) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.stringify(value);
  } catch (err) {
    return null;
  }
};

const decodeValue = <Type>(value: Nullish<string>) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value) as Type;
  } catch (err) {
    return null;
  }
};

const createStorage = (storage: Storage) => ({
  get: get(storage),
  set: set(storage),
  remove: remove(storage),
  clear: clear(storage),
});

const storage = {
  local: createStorage(localStorage),
  session: createStorage(sessionStorage),
};

export default storage;
